















































































































































import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

@Component
export default class Login extends Vue {
  protected email: string = '';
  protected password: string = '';
  protected rememberMe: boolean = true;
  protected authenticating: boolean = false;

  mounted() {
    if (this.$store.getters['auth/authenticated']) {
      this.$router.replace({ name: 'home' });
    }
  }

  performLogin() {
    if (this.authenticating) {
      return;
    }

    (this.$refs.validationObserver as InstanceType<typeof ValidationObserver>).validate().then((result) => {
      if (!result) {
        return;
      }

      this.authenticating = true;

      this.$store.dispatch('auth/login', { email: this.email, password: this.password })
        .then(() => {
          this.authenticating = false;

          document.location.href = '/';
        })
        .catch((err) => {
          this.authenticating = false;
          let text: string;
          if (err.errors && err.errors.email && err.errors.email[0] === 'These credentials do not match our records.') {
            text = 'Неверная пара логин/пароль';
          } else {
            text = '';
          }
          this.$vs.notify({
            title: 'Ошибка авторизации',
            text,
            color: 'danger',
          });
          console.error(err);
        });
    });
  }
}
